var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16_63)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.27 59.54C46.4354 59.54 59.54 46.4354 59.54 30.27C59.54 14.1046 46.4354 1 30.27 1C14.1046 1 1 14.1046 1 30.27C1 46.4354 14.1046 59.54 30.27 59.54Z",
    fill: "#FAFBFA",
    fillOpacity: 0.5,
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.37 46.89C25.22 42.09 17.7 37.77 15.37 30.74C13.53 25.21 15.9 18.12 22.48 17.64C28.51 17.2 30.27 21.09 30.27 21.09C30.27 21.09 32.03 17.2 38.06 17.64C44.64 18.12 47.01 25.2 45.17 30.74C42.83 37.77 35.52 42.09 30.37 46.89Z",
    stroke: "#2E63EE",
    strokeWidth: 1.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16_63"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60.53,
    height: 60.53,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyHeart);
export default __webpack_public_path__ + "static/media/empty-heart.07254a4a236d2e260bc7947970f5131f.svg";
export { ForwardRef as ReactComponent };